import React, { useState } from 'react';
import { AUTH_ENDPOINTS, FETCH_OPTIONS } from './config/constants';
import LoginPage from './pages/auth/Login';
import TimesheetPage from './pages/timesheet/Timesheet';
import AdminPage from './pages/admin/Administration';
import ChangePassword from './pages/auth/ChangePassword';
import FirstLoginPassword from './pages/auth/FirstLoginPassword';
import RootDashboard from './pages/root/Root';
import GestioneOperatori from './pages/root/Operatori';
import GestioneStrutture from './pages/root/Strutture';
import { useUser } from './context/usercontext';

// App principale
function App() {
  const [currentPage, setCurrentPage] = useState('login');
  const [userRole, setUserRole] = useState<'admin' | 'user' | 'root' | null>(null);
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);
  const { setUser } = useUser();

  // Verifica autenticazione al caricamento (auto-login)
  React.useEffect(() => {
    const checkAuth = async () => {
      try {
        const res = await fetch(AUTH_ENDPOINTS.VERIFY, {
          ...FETCH_OPTIONS
        });

        if (res.ok) {
          const data = await res.json();
          
          const role = data?.role === 'root' ? 'root' : (data?.role === 'admin' ? 'admin' : 'user');
          const userData = data.user || data;
          
          setUser(userData);
          setUserRole(role);
          if (role === 'root') {
            setCurrentPage('rootDashboard');
          } else if (role === 'admin') {
            setCurrentPage('admin');
          } else {
            setCurrentPage('timesheet');
          }
        } else {
          // Token scaduto o non valido: pulisci il context e sessionStorage
          setUser(null);
          setUserRole(null);
          setCurrentPage('login');
        }
      } catch (error) {
        console.log('Auth check failed, redirecting to login');
        // In caso di errore di rete o altro, pulisci comunque
        setUser(null);
        setUserRole(null);
        setCurrentPage('login');
      } finally {
        setIsCheckingAuth(false);
      }
    };

    checkAuth();
  }, [setUser]);

  const handleLogin = (role: 'admin' | 'user' | 'root') => {
    setUserRole(role);
    if (role === 'root') {
      setCurrentPage('rootDashboard');
    } else if (role === 'admin') {
      setCurrentPage('admin');
    } else {
      setCurrentPage('timesheet');
    }
  };

  const handleLogout = async () => {
    try {
      // Chiama l'API di logout
      await fetch(AUTH_ENDPOINTS.LOGOUT, {
        method: 'POST',
        ...FETCH_OPTIONS
      });
    } catch (error) {
      console.error('Errore durante il logout:', error);
    } finally {
      // Pulisci lo stato locale anche in caso di errore
      setUser(null);
      setCurrentPage('login');
      setUserRole(null);
    }
  };

  const handleForgotPassword = () => {
    setCurrentPage('cambioPassword');
  };

  const handleFirstLogin = () => {
    setCurrentPage('firstLoginPassword');
  };

  const handleFirstLoginComplete = (role: 'admin' | 'user' | 'root') => {
    // Dopo aver cambiato la password al primo accesso, setta il ruolo e vai alla pagina appropriata
    setUserRole(role);
    if (role === 'root') {
      setCurrentPage('rootDashboard');
    } else if (role === 'admin') {
      setCurrentPage('admin');
    } else {
      setCurrentPage('timesheet');
    }
  };

  const handleBackToLogin = () => {
    setCurrentPage('login');
  };

  const handlePasswordChanged = () => {
    setCurrentPage('login');
  };

  const handleRootNavigate = (page: string) => {
    switch(page) {
      case 'operatori':
        setCurrentPage('gestioneOperatori');
        break;
      case 'strutture':
        setCurrentPage('gestioneStrutture');
        break;
      case 'timesheet':
        setCurrentPage('timesheet');
        break;
      case 'admin':
        setCurrentPage('admin');
        break;
      default:
        setCurrentPage('rootDashboard');
    }
  };

  const handleBackToRoot = () => {
    setCurrentPage('rootDashboard');
  };

  if (isCheckingAuth) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-gray-600">Controllo autenticazione...</div>
      </div>
    );
  }

  return (
    <>
      {/* {userRole && (
        <div className="p-2 text-sm text-gray-600 text-right">
          Ruolo: {userRole}
        </div>
      )} */}
      {currentPage === 'login' && <LoginPage onLogin={handleLogin} onForgotPassword={handleForgotPassword} onFirstLogin={handleFirstLogin} />}
      {currentPage === 'cambioPassword' && <ChangePassword onBack={handleBackToLogin} onSuccess={handlePasswordChanged} />}
      {currentPage === 'firstLoginPassword' && <FirstLoginPassword onSuccess={handleFirstLoginComplete} />}
      {currentPage === 'timesheet' && <TimesheetPage onLogout={handleLogout} userName="Utente" />}
      {currentPage === 'admin' && <AdminPage onLogout={handleLogout} />}
      {currentPage === 'rootDashboard' && <RootDashboard onLogout={handleLogout} onNavigate={handleRootNavigate} />}
      {currentPage === 'gestioneOperatori' && <GestioneOperatori onBack={handleBackToRoot} />}
      {currentPage === 'gestioneStrutture' && <GestioneStrutture onBack={handleBackToRoot} />}
    </>
  );
}
export default App;
